import { trackCustomers } from "../../services/orderTrackService";
import useTrackingResource from "./useTrackingResource";

const EMPTY = [];

const useCustomers = (branchSwitch) => {
  const customers = useTrackingResource(trackCustomers, branchSwitch, EMPTY);
  return { customers: Array.isArray(customers) ? customers : EMPTY };
};

export default useCustomers;